import React from "react";

const Footer = () => {
  const handleAPICall = async (body: any, type: string) => {
    const response = await fetch(
      "../../services/dataService/CronJobFetchSpreadsheet.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }
    );
    const result = await response.json();

    if (response.ok) {
      console.log(`Data has been fetched for ${type}`);
    } else {
      // console.log("Error: " + result.message);
      return Promise.reject(result.message);
    }
  };

  const handleGetCSVData = async () => {
    const csvUrlVKU =
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTBg6tztAv_TvyWrsEfe71AthXv6Aw2Qs1LD0CaBFioCCo_PCLfmfEQmH6u8vhwiV2MAY2Vz0jiBfXw/pub?gid=0&single=true&output=csv";
    const csvUrlPlus =
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTBg6tztAv_TvyWrsEfe71AthXv6Aw2Qs1LD0CaBFioCCo_PCLfmfEQmH6u8vhwiV2MAY2Vz0jiBfXw/pub?gid=1571264509&single=true&output=csv";

    const outputJsonPathVKU = "../../data/vkuData.json";
    const outputJsonPathPlus = "../../data/plusData.json";

    const dateHeaders = [
      "fDate",
      "fStartTime",
      "fEndTime",
      "sDate",
      "sStartTime",
      "sEndTime",
    ];
    const detailHeaders = ["price", "availablePlaces", "extraDescription"];
    const headersVKU = [...dateHeaders, ...detailHeaders];

    const headersPlus = [
      ...dateHeaders,
      "tDate",
      "tStartTime",
      "tEndTime",
      ...detailHeaders,
    ];

    const postVKUData = {
      csvUrl: csvUrlVKU,
      outputJsonPath: outputJsonPathVKU,
      headers: headersVKU,
    };

    const postPlusData = {
      csvUrl: csvUrlPlus,
      outputJsonPath: outputJsonPathPlus,
      headers: headersPlus,
    };

    try {
      await Promise.all([
        handleAPICall(postVKUData, "VKU"),
        handleAPICall(postPlusData, "Notheilfer"),
      ]);
    } catch (error) {
      console.error("Error updating the timeschedules:", error);
    }
  };

  return (
    <footer className="bg-dark-blue text-white pt-10">
      <div className="mx-auto px-4 w-full gap-6">
        {/* Left Section: Logo and Contact Information */}
        <div className="flex justify-between w-full">
          <div className="w-full">
            <h2 className="text-2xl font-bold mb-4">
              <img
                src={"/assets/logo/logoBardh.svg"}
                alt="Logo White"
                className="h-6 w-52 object-fit"
              />
            </h2>
            <h3 className="font-semibold text-lg mb-2">Öffnungszeiten</h3>
            <div>
              <p className="font-bold">Montag bis Freitag</p>
              <p className="ml-2">08.00 bis 17.30 Uhr</p>
            </div>
            <div>
              <p className="font-bold">Samstag</p>
              <p className="ml-2">08.00 bis 16.00 Uhr</p>
            </div>
          </div>
          <div className="text-center -ml-40 w-full max-md:ml-0">
            <div className="mb-10 max-md:mb-0 w-full text-left ml-20 max-md:ml-0 max-md:text-center">
              <p>Kontakt</p>
            </div>
            <div className="flex space-y-20 w-full">
              <div className="text-left flex flex-col space-y-2 w-full text-wrap">
                <a
                  href="https://www.google.com/maps?q=Römerstrasse+76+8404+Winterthur"
                  rel="noreferrer"
                  target="_blank"
                >
                  📍 : Römerstrasse 76 8404 Winterthur
                </a>
                <a href="tel:+41764727563">📞: +41 76 472 75 63</a>
                <a href="mailto:lumifahrschule@gmail.com">
                  📧: lumifahrschule@gmail.com
                </a>
              </div>
            </div>
            <div className="md:hidden">
              <div className="flex items-center justify-end space-y-4 md:space-y-0 md:space-x-4 max-md:space-x-4 max-md:flex-row max-md:items-center max-md:justify-start">
                {/* Instagram */}
                <p className="flex mt-3">Folgen Sie uns</p>
                <a
                  href="#"
                  className="text-white hover:text-blue-300 transition"
                  aria-label="Instagram"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16 3H8a5 5 0 00-5 5v8a5 5 0 005 5h8a5 5 0 005-5V8a5 5 0 00-5-5z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16 11.37A4 4 0 1112.63 8a4 4 0 013.37 3.37z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.5 6.5h.01"
                    />
                  </svg>
                </a>
                {/* Facebook */}
                <a
                  href="#"
                  className="text-white hover:text-blue-300 transition"
                  aria-label="Facebook"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22.675 0h-21.35C.597 0 0 .598 0 1.333v21.333C0 23.402.597 24 1.325 24H12v-9.294H9.413v-3.633H12v-2.665c0-2.656 1.635-4.103 4.026-4.103 1.144 0 2.131.085 2.42.123v2.808h-1.66c-1.304 0-1.557.619-1.557 1.529v2.307h3.113l-.405 3.633H15.23V24h5.672C23.403 24 24 23.402 24 22.667V1.333C24 .598 23.403 0 22.675 0z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Right Section: Social Media Icons */}
          <div className="float-end max-md:hidden">
            <div className="mb-10 text-right text-nowrap">
              <p>
                Folgen Sie <a onClick={handleGetCSVData}>uns</a>
              </p>
            </div>
            <div className="flex  items-center justify-end space-y-4 md:space-y-0 md:space-x-4 max-md:flex-col max-md:items-end">
              {/* Instagram */}
              <a
                href="#"
                className="text-white hover:text-blue-300 transition"
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16 3H8a5 5 0 00-5 5v8a5 5 0 005 5h8a5 5 0 005-5V8a5 5 0 00-5-5z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16 11.37A4 4 0 1112.63 8a4 4 0 013.37 3.37z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.5 6.5h.01"
                  />
                </svg>
              </a>
              {/* Facebook */}
              <a
                href="#"
                className="text-white hover:text-blue-300 transition"
                aria-label="Facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M22.675 0h-21.35C.597 0 0 .598 0 1.333v21.333C0 23.402.597 24 1.325 24H12v-9.294H9.413v-3.633H12v-2.665c0-2.656 1.635-4.103 4.026-4.103 1.144 0 2.131.085 2.42.123v2.808h-1.66c-1.304 0-1.557.619-1.557 1.529v2.307h3.113l-.405 3.633H15.23V24h5.672C23.403 24 24 23.402 24 22.667V1.333C24 .598 23.403 0 22.675 0z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section: Copyright and Back to Top */}
      <div className="flex flex-col bg-[#14213d] mt-5 items-center justify-center">
        <p className="text-sm">© 2025 Fahrschul-Kurse</p>
        <p className="text-sm">Designed by Kamidi.co</p>
        {/* <a
            href="#"
            className="bg-white text-blue-900 rounded-full p-2 mt-4 hover:bg-blue-200 transition"
            aria-label="Back to top"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 15l7-7 7 7"
              />
            </svg>
          </a> */}
      </div>
    </footer>
  );
};

export default Footer;
